/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-15T11:07:07.079
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getCardOperationLogEditInit,
	getCardOperationLogView
} from '@api/rentmanage/CardOperationLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getCardOperationLogEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCardOperationLogEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCardOperationLogView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCardOperationLogView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
